import * as React from 'react';
import { useTheme } from '@material-ui/core/styles';
import { XXL_COLORS } from '../../theme/colors';
import { SPACE_GROTESK_FONT_FAMILY } from '../../theme/fonts';

type SectionTitleProps = {
  children: React.ReactNode;
  className?: string;
};

export default function SectionTitle({ children, className }: SectionTitleProps) {
  const theme = useTheme();
  const tokens = (theme as { xxlprint?: typeof XXL_COLORS }).xxlprint || XXL_COLORS;

  return (
    <div
      className={className}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        marginBottom: 14,
      }}
    >
      <span
        aria-hidden
        style={{
          width: 11,
          height: 11,
          flexShrink: 0,
          backgroundColor: tokens.accent,
        }}
      />
      <span
        style={{
          fontFamily: SPACE_GROTESK_FONT_FAMILY,
          fontSize: 15,
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.06em',
          color: tokens.sectionTitle,
        }}
      >
        {children}
      </span>
    </div>
  );
}
